import * as Types from '../generated/types';

import { gql } from '@apollo/client';
import { CarModelNodeFragmentDoc } from './carModelNode.generated';
export type CarSubModelNodeFragment = { __typename?: 'CarSubModelNode', id: string, name: string, localName?: string | null, carModel: { __typename?: 'CarModelNode', id: string, name: string, localName?: string | null, brand: { __typename?: 'BrandNode', id: string, name: string } } };

export const CarSubModelNodeFragmentDoc = gql`
    fragment CarSubModelNode on CarSubModelNode {
  id
  name
  localName
  carModel {
    ...CarModelNode
  }
}
    ${CarModelNodeFragmentDoc}`;